import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@ohif/ui-next';
import ToggleGroup from '../ToggleGroup';
import { TrackedAssessment } from '../../services/ReportAssessmentService';

interface FindingsAssessmentProps {
  rows: readonly TrackedAssessment[];
  onClassificationChange: (index: number, value?: boolean) => void;
  onDetectionChange: (index: number, value?: boolean) => void;
}

export default function FindingsAssessment({
  rows,
  onClassificationChange,
  onDetectionChange,
}: FindingsAssessmentProps) {
  return (
    <Table
      noScroll
      className="text-sm"
    >
      <TableHeader>
        <TableRow className="hover:bg-transparent hover:[&>th]:text-white">
          <TableHead
            scope="col"
            className="px-1 font-semibold text-white"
          >
            <span className="sr-only">Finding</span>
          </TableHead>
          <TableHead
            scope="col"
            className="px-1 text-center font-semibold text-white"
          >
            Classification
          </TableHead>
          <TableHead
            scope="col"
            className="px-1 text-center font-semibold text-white"
          >
            Detection
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {rows.map((finding, index) => {
          const rowLabel = finding.name ? `Finding ${finding.name}` : `Finding ${index + 1}`;

          return (
            <TableRow
              key={index}
              className="hover:[&>th]:text-white hover:[&>td]:text-white"
            >
              <TableHead
                scope="row"
                className="h-auto px-1 py-1 font-medium text-white"
              >
                {rowLabel}
              </TableHead>

              <TableCell className="px-1 py-1">
                <ToggleGroup
                  value={finding.isClassificationCorrect}
                  onChange={value => onClassificationChange(index, value)}
                  disabled={finding.isSubmitted}
                  label={`Classification correct for ${rowLabel}`}
                />
              </TableCell>

              <TableCell className="px-1 py-1">
                <ToggleGroup
                  value={finding.isDetectionCorrect}
                  onChange={value => onDetectionChange(index, value)}
                  disabled={finding.isSubmitted}
                  label={`Detection correct for ${rowLabel}`}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
